import { Injectable, Type } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderUIStep } from '../remote-action-builder-steps';
import { WorktypeSelectComponent } from 'src/app/_components/remote-action-step/worktype-select/worktype-select.component';

@Injectable()
export class WorktypeSelectRemoteActionBuilderUIStep
  implements GenericRemoteActionBuilderUIStep {
  public isLast: boolean = false;

  constructor(private logger?: LoggingService) {}

  public getComponent(): Type<any> {
    this.logger.log(
      this.constructor.name,
      '- getComponent for Worktype-Select called'
    );
    return WorktypeSelectComponent;
  }

  public isVisible(currentData: any): boolean {
    // Always Visible
    return true;
  }
}
